export const SUMMARY = 'SUMMARY';
export const WORDING = 'WORDING';
export const SCHEDULE = 'SCHEDULE';
export const MTA = 'MTA_ACCEPT';
export const IPID = 'IPID';
